// extracted by mini-css-extract-plugin
module.exports = {"blocked":"g_b","loader":"g_c","img":"g_r","wrapper":"g_s","product__wave":"g_t"};